import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { UserSwitch } from "@phosphor-icons/react";
import { toast } from "sonner";

export function ChangeDispatcher({ carrier, dispatchers, onClose, onSaved }) {
  const [pick, setPick] = useState("none");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setPick(carrier?.assigned_dispatcher || "none"); }, [carrier]);
  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/carriers/${carrier.id}/dispatcher`, { dispatcher_id: pick === "none" ? null : pick });
      toast.success("Dispatcher changed"); onSaved(); onClose();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!carrier} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white border-slate-200 max-w-md" data-testid="change-dispatcher-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><UserSwitch size={20} className="text-blue-600" />Change Dispatcher</DialogTitle>
          <DialogDescription>{carrier?.carrier_name} · currently {carrier?.assigned_dispatcher_name || "Unassigned"}</DialogDescription></DialogHeader>
        <Select value={pick} onValueChange={setPick}>
          <SelectTrigger className="bg-white border-slate-300" data-testid="change-dispatcher-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="none">Unassigned</SelectItem>{dispatchers.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
        </Select>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} data-testid="change-dispatcher-cancel">Cancel</Button>
          <Button onClick={save} disabled={saving || pick === (carrier?.assigned_dispatcher || "none")} className="bg-blue-600 text-white hover:bg-blue-700" data-testid="change-dispatcher-save">{saving ? "Saving…" : "Save"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
